export default "__VITE_ASSET__CnW1PwaQ__"